import { DateTime } from 'luxon'

export interface DateTextProps {
  date: string | null | undefined
}

export const DateText = ({ date }: DateTextProps) => {
  if (!date) {
    return null
  }
  const utcDate = DateTime.fromISO(date, { zone: 'utc' })

  return <span data-testid="date-label">{utcDate.toFormat('MMM d, yyyy')}</span>
}
